import { interopDefault } from '~/router/utils'

export const adminBanksRoutes = [
  {
    name: '__admin_banks_index',
    path: '/admin/banks/',
    component: () =>
      interopDefault(
        import(
          '~/pages/admin/banks/index.vue' /* webpackChunkName: "pages-car-admin-banks-index" */
        )
      ),
    redirect: { name: '__admin_banks_loan_stats' },
    children: [
      {
        name: '__admin_banks_loan_stats',
        path: 'loan-stats',
        component: () =>
          interopDefault(
            import(
              '~/pages/admin/banks/loan-stats.vue' /* webpackChunkName: "pages-admin-banks-loan-stats" */
            )
          )
      },
      {
        name: '__admin_banks_loan_applications',
        path: 'loan-applications',
        component: () =>
          interopDefault(
            import(
              '~/pages/admin/banks/loan-applications.vue' /* webpackChunkName: "pages-admin-banks-loan-applications" */
            )
          )
      }
    ]
  }
]
